<template>
  <div class="upload-cert-container upload-education-container">
    <template v-if="status === 0">
      <div class="upload-tips">拍照上传学历证书</div>
      <div class="photo-item">
        <Oss @uploadSucess="educationSuccess" browse_button="uploadEduBtn" @fileChange="selectedEdu"
          :actionFile="eduFile" container="eduContainer" :params='eduParams'>
          <div id="eduContainer" class="photo-item">

            <p id="uploadEduBtn" v-if="educationPicUrlList && educationPicUrlList.length">
              <img :src="educationPicUrlList[0]" alt="请点击上传/拍摄毕业证书" class="img" />
              <span class="upload-msg">重新上传</span>
            </p>

            <p v-else id="uploadEduBtn">
              <img src="~@/assets/img/cert-education.png" alt="请点击上传/拍摄毕业证书" class="img" />
              <span class="upload-msg">请点击上传/拍摄毕业证书</span>
            </p>
          </div>
        </Oss>

      </div>
      <a href="javascript:;" class="commit common-btn"
        :class="{disable: !educationPicList || educationPicList.length === 0}" @click="commit">提交认证</a>
    </template>
    <template v-else>
      <div class="process">
        <ul class="process-list">
          <li class="process-item">
            <p class="date">{{userData.academicCommitTime | formatTime}}</p>
            <p class="option">你提交了学历认证信息</p>
            <div class="imgs">
              <img v-if="educationPicUrlList && educationPicUrlList.length" :src="educationPicUrlList[0]" class="img" />
              <img src="~@/assets/img/certed.png" alt="已认证" class="certed" v-if="status === 3" />
            </div>
          </li>
          <li class="process-item">
            <p class="option" v-if="status === 1">待后台审核…</p>
            <template v-if="status === 2">
              <p class="date">{{userData.academicAuthTime | formatTime}}</p>
              <p class="option">后台审核不通过，</p>
              <p class="reason"><span class="strong">不通过原因：</span>{{userData.academicAuthReason}}</p>
            </template>
            <template v-if="status === 3">
              <p class="date">{{userData.academicAuthTime | formatTime}}</p>
              <p class="option">后台审核通过</p>
            </template>
          </li>
        </ul>
        <a href="javascript:;" class="re-commit common-btn" v-if="status === 2 || status === 3" @click="reCert">重新认证</a>
      </div>
    </template>
    <div class="tips-con">
      <p class="tips">1、支持上传学信网学历认证截图，学信网认证地址</p>
      <p class="copy-con" ref="copy-con">
        <span class="link">https://my.chsi.com.cn/archive/gdjy/xl/show.action</span>
        <a href="javascript:;" class="btn"
          @click.stop="execCopy('https://my.chsi.com.cn/archive/gdjy/xl/show.action')">复制</a>
      </p>
      <p class="tips">2、在读学生可上传学生证/录取通知书等进行认证。</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { copy, isIOS, transferBytes, watermark } from '@/utils/tools'
import { UPLOAD_TYPE } from '@/config/constant'
import Oss from '@/components/common/oss'

const getRotate = () => {
  return import('@/utils/rotateImg.js')
}

export default {
  name: 'uploadCert',
  components: {
    Oss
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    status () {
      return this.userData.academicAuth
    }
  },
  data () {
    return {
      // 0: 未上传; 1: 待审核; 2: 未通过; 3: 通过
      educationPicList: null,
      educationPicUrlList: null,
      eduParams: { type: UPLOAD_TYPE.schooling },
      eduFile: null

    }
  },
  watch: {
    userData (val) {
      if (val) {
        this.educationPicList = this.userData.educationPicList || []
        this.educationPicUrlList = this.userData.educationPicUrlList || []
      }
    }
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),

    educationSuccess ({ picId, url }) {
      this.educationPicUrlList = [url]
      this.educationPicList = [picId]
      this.eduFile = null
    },

    selectedEdu (e) {
      this.eduFile = e.file
    },

    handleImg (e) {
      let target = e.target
      let file = target.files[0]
      if (isIOS()) {
        getRotate().then(({ rotatePhoto }) => {
          rotatePhoto(file, (res) => {
            this.uploadImg(res, target)
          })
        })
      } else {
        this.uploadImg(file, target)
      }
    },
    uploadImg (file, target) {
      this.$root.openLoading()
      // 将文件转换成bytes后上传
      transferBytes(file).then(res => {
        this.$http('/api/member/upload/pic', {
          type: 5,
          pic: res
        }).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            this.educationPicList = [res.data]
          } else {
            this.$toast(res.msg)
            target.value = ''
          }
        }, err => {
          this.$root.closeLoading()
          this.$toast(err)
          target.value = ''
        })
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
        target.value = ''
      })
    },
    commit () {
      if (this.educationPicList.length) {
        this.$root.openLoading()
        // 保存个人信息
        this.$http('/api/member/save', {
          educationPicList: this.educationPicList,
          academicAuth: 1
        }).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            // 更新个人信息
            this.updateUserData({
              educationPicList: this.educationPicList,
              educationPicUrlList: this.educationPicUrlList,
              academicAuth: 1,
              academicCommitTime: new Date().getTime()
            })
          } else {
            this.$toast(res.msg)
          }
        }, err => {
          this.$root.closeLoading()
          this.$toast(err)
        })
      }
    },
    reCert () {
      this.updateUserData({
        educationPicList: null,
        academicAuth: 0
      })
    },
    execCopy (text) {
      copy(text, this.$refs['copy-con']).then(res => {
        this.$toast('复制成功')
      }, () => {
        this.$toast('复制失败')
      })
    }
  },
  mounted () {
    let { educationPicList, educationPicUrlList } = this.userData
    if (educationPicList && educationPicList.length && educationPicUrlList && educationPicUrlList.length) {
      this.educationPicList = educationPicList
      this.educationPicUrlList = educationPicUrlList
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.upload-cert-container.upload-education-container {
  .imgs {
    .img {
      margin-right: 20px;
      width: 230px;
      height: auto !important;
    }
  }
  .tips-con {
    margin-top: 150px;
    .tips {
      color: #9b9b9b;
      font-size: 28px;
      line-height: 40px;
    }
  }
  .copy-con {
    margin: 16px 0 32px;
    padding-left: 1.5em;
    font-size: 28px;
    display: flex;
    justify-content: space-between;
    .btn {
      margin-left: 20px;
      flex: 0 0 100px;
      color: $mainColor;
      font-size: 28px;
      text-align: right;
    }
    .link {
      word-break: break-all;
      flex: 1 1 auto;
      color: #000;
      font-size: 28px;
    }
  }
}

.upload-cert-container .photo-item {
  height: auto;
  .img {
    position: relative;
    border-radius: 15px;
    display: block;
  }
}
</style>
